import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { userDenyActions } from '../../../application/actions/userDeny';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETBYID
export function* getByIdFetch(e) {
    yield put(userDenyActions.conexionGetById({connection:true}));
    try {
        const  params  = e.payload;
        const url = `userdeny/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(userDenyActions.getById({data}));
    } catch (err) {
        yield put(userDenyActions.errorGetById({error:true, message:err.message}));
    } finally {
        yield put(userDenyActions.conexionGetById({connection:false}));
    }
}

// CREATE
export function* createFetch(e) {
    yield put(userDenyActions.conexionCreate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `userdeny`
        const response = yield call(
            apiRequest.post,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(userDenyActions.create({result}));
    } catch (err) {
        yield put(userDenyActions.errorCreate({error:true, message:err.message}));
    } finally {
        yield put(userDenyActions.conexionCreate({connection:false}));
    }
}


export function* watchFetchUserDeny() {

    yield takeLatest(userDenyActionsSaga.getById.type,  getByIdFetch);
    yield takeLatest(userDenyActionsSaga.create.type,  createFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchUserDeny);
}


const getById = createAction('userDenySaga/getById');
const create = createAction('userDenySaga/create');

export const userDenyActionsSaga = {
    getById,
    create,
};
